import {
  Clock,
  EnvelopeOpen,
  GlobeHemisphereWest,
  PhoneCall,
} from '@phosphor-icons/react';
import { TFunction } from 'i18next';
import { ReactElement } from 'react';

import { getCountryUtils } from '../../utils/countryUtils';

export type PlanBenefitTypesKeys =
  | 'bundle_validity'
  | 'call_minutes'
  | 'call_minutes_international'
  | 'countries'
  | 'texts';

type PlanBenefitDetails = Record<
  PlanBenefitTypesKeys,
  { icon: ReactElement; label: string }
>;

export const getPlanBenefitDetails = (
  t: TFunction,
  count: number,
  countryKeys?: string[],
): PlanBenefitDetails => {
  const { getCountryNameTranslation } = getCountryUtils(t);
  const twoCountriesLabel = (countryKeys: string[]) => {
    if (countryKeys.length === 2) {
      return `${getCountryNameTranslation(
        countryKeys[0],
      )} & ${getCountryNameTranslation(countryKeys[1])}`;
    }
    return t('plan_card.benefit.countries');
  };

  return {
    bundle_validity: {
      icon: <Clock size={24} weight="bold" />,
      label: t('plan_card.benefit.bundle_validity', 'Days'),
    },
    call_minutes: {
      icon: <PhoneCall size={24} weight="fill" />,
      label: t('plan_card.benefit.call_minutes', 'Local Mins'),
    },
    call_minutes_international: {
      icon: <PhoneCall size={24} weight="fill" />,
      label: t('plan_card.benefit.call_minutes_international', 'Intl Mins'),
    },
    countries: {
      icon: <GlobeHemisphereWest size={24} weight="fill" />,
      label:
        countryKeys?.length === 2
          ? twoCountriesLabel(countryKeys)
          : t('plan_card.benefit.countries', {
              count,
              defaultValue_one: 'Country',
              defaultValue_other: 'Countries',
            }),
    },

    texts: {
      icon: <EnvelopeOpen size={24} weight="bold" />,
      label: t('plan_card.benefit.texts', 'SMS Texts'),
    },
  };
};
